import { ca } from '@cian/analytics';

import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

export const trackSuburbanBannerClick = (offer: IOfferSchema) => {
  ca('eventSite', {
    action: `Click`,
    category: 'Ad',
    name: 'oldevent',
    products: [
      {
        id: offer.id,
        offerType: offer.offerType,
        position: 1,
      },
    ],
  });
};

export const trackSuburbanBannerScroll = (offer: IOfferSchema) => {
  ca('eventSite', {
    action: `Scroll`,
    category: 'Ad',
    name: 'oldevent',
    products: [
      {
        id: offer.id,
        offerType: offer.offerType,
        position: 1,
      },
    ],
  });
};
